"use client";

import { HeroSection } from "./_components/hero-section";
import { SwapperPortalSection } from "./_components/swapper-portal-section";
import { LeaderboardSpotlightSection } from "./_components/leaderboard-spotlight-section";
import { QuestsSpotlightSection } from "./_components/quests-spotlight-section";
import { HowItWorksSection } from "./_components/how-it-works-section";
import { BackedBySection } from "@/components/backed-by-section";

export default function HomePage() {
  return (
    <div className="w-full">
      {/* Section 1: Hero - "Swapper Portal" with tagline and partner logos */}
      <HeroSection />

      {/* Section 2: What is the Swapper Portal? - Quests, Referrals, Rewards cards */}
      <SwapperPortalSection />

      {/* Section 3: Leaderboard Spotlight - Top user showcase */}
      <LeaderboardSpotlightSection />

      {/* Section 4: Quests & Challenges - Social media quest cards */}
      <QuestsSpotlightSection />

      {/* Section 5: How It Works - Three-step guide */}
      <HowItWorksSection />

      {/* Section 6: Backed by the best - Investor/partner logos */}
      <BackedBySection />
    </div>
  );
}
